"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _LayoutGrid = _interopRequireDefault(require("./LayoutGrid"));

var _ModuleEkultur = _interopRequireDefault(require("./ModuleEkultur"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const layouts = {
  "grid": _LayoutGrid.default
};
const templates = {
  "ekultur": _ModuleEkultur.default
};

const ArticleReferences = ({
  className,
  language = "no",
  layout = "grid",
  references = []
}) => {
  const localeId = "locale:" + language;

  const renderReference = ({
    referenceType,
    reference,
    content
  }) => {
    let title = content && content.title || reference && reference.title || undefined;

    if (typeof title === "object") {
      title = title[localeId] || undefined;
    }

    const ModuleTemplate = referenceType && templates[referenceType];

    if (ModuleTemplate) {
      return _react.default.createElement(ModuleTemplate, _extends({}, reference, {
        title: title
      }));
    }

    return _react.default.createElement("li", null, title);
  };

  if (!references.length) {
    return false;
  }

  const LayoutTemplate = layout && layouts[layout];

  if (LayoutTemplate) {
    return _react.default.createElement(LayoutTemplate, null, references.map(reference => renderReference(reference)));
  }

  return _react.default.createElement("div", {
    className: className
  }, references.map(reference => renderReference(reference)));
};

var _default = ArticleReferences;
exports.default = _default;
module.exports = exports.default;